/**
 * Roman-like ordinal converter using the english alphabet
 * examples:
 *
 * 1 -> A
 * 2 -> B
 * 3 -> C
 * ...
 * 26 -> Z
 * 27 -> AA
 * ...
 * 52 -> AZ
 * 53 -> BA
 * @param count - The number to convert to 26-based english alphabet counter.
 * Floats will be rounded to the nearest integer.
 * @returns a string representing the number in the 26-based english alphabet
 */
export const ordinalAlphabeticBy = (incomingCount: number): string => {
  if (!incomingCount) {
    return ''
  }

  let count = Math.round(incomingCount)

  const characters: string[] = []

  while (count > 0) {
    count-- // Decrease count to make it 0-indexed
    characters.unshift(String.fromCharCode(65 + (count % 26))) // Convert to an english alphabet letter
    count = Math.floor(count / 26) // Move to the next "digit"
  }

  return characters.join('')
}
